import {DateRangeValue} from 'common/models/survey';

import isValidStringDate from './isValidStringDate';

const isDateRange = (value: unknown): value is DateRangeValue => {
    return value !== null && typeof value === 'object' && 'begin' in value && 'end' in value;
};

export const isValidDateRange = (value: unknown): value is DateRangeValue => {
    return (
        value !== null &&
        typeof value === 'object' &&
        isDateRange(value) &&
        isValidStringDate(value.begin) &&
        isValidStringDate(value.end)
    );
};

export default isDateRange;
